export function getBusToursText(getStringRes, key) {
  return getStringRes(key);
}

// Decorative category labels shown as a colored pill on each card — cosmetic variety only
// (there's no "route category" field on the real tour data), cycled by position so every card
// in a page of 5 (1 featured + 4 grid) gets a different one. Same idea as charterDeals.js's
// hardcoded `badge` field, just generated instead of hand-authored per entry.
export const BUS_TOUR_BADGES = [
  { label: "Populārs maršruts", tone: "rose" },
  { label: "Vēsturisks centrs", tone: "sky" },
  { label: "Dabas ceļojums", tone: "mint" },
  { label: "Kultūras mantojums", tone: "amber" },
  { label: "Iecienīts galamērķis", tone: "violet" },
];
